import { useEffect } from "react";

import { useFormikContext } from "formik";

import { FormikTextInput } from "@sso/components/Formik";
import FormikSelectWithBlur from "@sso/components/Formik/FormikSelectWtihBlur";
import {
  LicenceType,
  licenceTypeOption,
  PaymentType,
  paymentTypeOption,
  PricingRuleKeys,
  SoftwareLicenceFormValues,
  SoftwareLicenceSummaryKeys,
} from "@sso/types";

const LicenceTypeGeneralFields = () => {
  const { setFieldValue, values } = useFormikContext<SoftwareLicenceFormValues>();

  return (
    <>
      <FormikTextInput label="Name" name={SoftwareLicenceSummaryKeys.NAME} />
      <FormikSelectWithBlur
        name={SoftwareLicenceSummaryKeys.LICENCE_TYPE}
        label="Type"
        items={licenceTypeOption}
        onChange={value => {
          if (value !== LicenceType.CONCURRENT) {
            setFieldValue("defaultConcurrentUsers", undefined);
          }

          switch (value) {
            case LicenceType.API:
              setFieldValue(SoftwareLicenceSummaryKeys.PAYMENT_TYPE, PaymentType.PaymentOnAccount);
              setFieldValue("pricingRules", []);
              break;
            case LicenceType.TRIAL:
              setFieldValue(SoftwareLicenceSummaryKeys.PAYMENT_TYPE, PaymentType.Free);
              setFieldValue("pricingRules", []);
              break;
            case LicenceType.SINGLE_USER:
              setFieldValue("pricingRules", [{}]);
              break;
            case LicenceType.CONCURRENT:
              setFieldValue("pricingRules", [{ [PricingRuleKeys.MIN_RANGE]: 1 }]);
              break;
            default:
              break;
          }
        }}
      />
      <FormikSelectWithBlur
        name={SoftwareLicenceSummaryKeys.PAYMENT_TYPE}
        label="Payment Type"
        items={paymentTypeOption}
        disabled={
          values[SoftwareLicenceSummaryKeys.LICENCE_TYPE] === LicenceType.API ||
          values[SoftwareLicenceSummaryKeys.LICENCE_TYPE] === LicenceType.TRIAL
        }
      />
    </>
  );
};

export default LicenceTypeGeneralFields;
